<app-modal-header [title]="data.title" />

<app-modal-body>
  <div class="mms">
    <input
      #search
      type="search"
      class="field-input mms__search"
      [value]="queryText"
      [placeholder]="data.placeholder"
      (input)="onInput(search.value)"
    />

    @if (selected.length) {
      <div class="mms__chips">
        @for (opt of selected; track opt.id) {
          <span class="chip">
            {{ opt.label }}
            <button type="button" class="mms__chip-remove" [attr.aria-label]="'Remove ' + opt.label" (click)="remove(opt)">×</button>
          </span>
        }
      </div>
    }

    @if (limitMessage) {
      <p class="mms__limit">{{ limitMessage }}</p>
    }

    <div class="mms__list" (scroll)="onListScroll($event)">
      @for (opt of options; track opt.id) {
        <label class="mms__option" [class.mms__option--on]="isSelected(opt)">
          <input #box type="checkbox" [checked]="isSelected(opt)" (change)="toggle(opt); box.checked = isSelected(opt)" />
          <span class="mms__option-label">{{ opt.label }}</span>
        </label>
      }
      @if (isLoading) {
        <p class="mms__status">Loading…</p>
      } @else if (!options.length) {
        <p class="mms__status">No matches{{ queryText ? ' for "' + queryText + '"' : '' }}.</p>
      }
    </div>
  </div>
</app-modal-body>

<app-modal-footer>
  <button type="button" class="btn--secondary" (click)="modalRef.close([])">Clear</button>
  <button type="button" class="btn--primary" (click)="modalRef.close(selected)">
    Done{{ selected.length ? ' (' + selected.length + ')' : '' }}
  </button>
</app-modal-footer>
